export interface ContactForm {
  name: string;
  companyName: string;
  email: string;
  phone: string;
  siteType: string;
  hasExistingWebsite: string;
  message: string;
  privacyConsent: boolean;
}

export interface ContactFormPayload extends ContactForm {
  website: string;
}

export const SITE_TYPE_OPTIONS = [
  { value: 'landing', label: 'Landing oldal' },
  { value: 'company', label: 'Céges weboldal' },
  { value: 'restaurant', label: 'Vendéglátói weboldal' },
  { value: 'b2b', label: 'B2B oldal' },
  { value: 'webshop', label: 'Webshop' },
  { value: 'custom', label: 'Egyedi webes rendszer' },
  { value: 'supervision', label: 'Csak webfelügyelet érdekel' },
  { value: 'unknown', label: 'Még nem tudom' },
] as const;
